import React from "react";
import "../CSS/Icon.css";

function Services() {
    return (
        <div>
            <div className="container-fluid text-center services-container">
                <h2 className="services-title">SERVICES</h2>
                <h6 className="services-subtitle">
                    We provide Domestic and International tours & travel services with **safety** and **accuracy**. Come and explore!
                </h6>
                <br />

                <div className="row slideanim justify-content-center">
               
                    <div className="col-sm-3 service-card">
                        <i className="bi bi-buildings-fill icon-xlarge red-icon"></i>
                        <h4>Hotel Booking</h4>
                        <p>We provide Domestic and International Hotel Bookings.</p>
                    </div>
                    <div className="col-sm-3 service-card">
                        <i className="bi bi-airplane-fill icon-xlarge black-icon"></i>
                        <h4>Flight Booking</h4>
                        <p>We offer Domestic and International Flight Bookings.</p>
                    </div>
                    <div className="col-sm-3 service-card">
                        <i className="bi bi-suitcase-fill icon-xlarge blue-icon"></i>
                        <h4>Travel Booking</h4>
                        <p>We book cars, cabs, and other travel transport.</p>
                    </div>
                </div>

                <br />

                <div className="row slideanim justify-content-center">
                    <div className="col-sm-3 service-card">
                        <i className="bi bi-tsunami icon-xlarge purple-icon"></i>
                        <h4>Cruises Booking</h4>
                        <p>We offer luxury cruise bookings.</p>
                    </div>
                    <div className="col-sm-3 service-card">
                        <i className="bi bi-train-front-fill icon-xlarge green-icon"></i>
                        <h4>Rail Booking</h4>
                        <p>We also provide rail ticket booking services.</p>
                    </div>
                    <div className="col-sm-3 service-card">
                        <i className="bi bi-heart-fill icon-xlarge pink-icon"></i>
                        <h4>Amazing Tour</h4>
                        <p>Enjoy safe, accurate, and amazing tours with us.</p>
                    </div>
                </div>

                <br />
                <br />
            </div>
        </div>
    );
}

export default Services;
